import mapboxgl from "mapbox-gl";

interface GeoJSONFeature {
  type: string;
  geometry: {
    type: string;
    coordinates:
      | [number, number][]
      | [number, number][][]
      | [number, number][][][];
  };
  properties?: Record<string, unknown>;
}

interface GeoJSONData {
  type: string;
  features: GeoJSONFeature[];
}

/**
 * Calculate bounds from GeoJSON data
 * @param geojsonData The GeoJSON data
 * @returns LngLatBounds object containing the bounds of the route data
 */
export function findRouteBounds(
  geojsonData: GeoJSONData,
): mapboxgl.LngLatBounds {
  const bounds = new mapboxgl.LngLatBounds();

  if (geojsonData.features) {
    for (const feature of geojsonData.features) {
      if (feature.geometry && feature.geometry.type === "LineString") {
        for (const coord of feature.geometry.coordinates as [
          number,
          number,
        ][]) {
          bounds.extend(coord);
        }
      } else if (
        feature.geometry &&
        feature.geometry.type === "MultiLineString"
      ) {
        for (const lineString of feature.geometry.coordinates as [
          number,
          number,
        ][][]) {
          for (const coord of lineString) {
            bounds.extend(coord);
          }
        }
      }
    }
  }

  return bounds;
}
